// removed by extract-text-webpack-plugin
module.exports = {"wrap":"Modal-wrap","block":"Modal-block","noScroll":"Modal-noScroll","overflowDisable":"Modal-overflowDisable","dotCloseButton":"Modal-dotCloseButton","closeButton":"Modal-closeButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/index.css
// module id = 1718
// module chunks = 0